import {FaqPage} from "../features/faq/FaqPage"

export default FaqPage.Page
